import * as React from 'react'
import classnames from 'classnames'
import '../style.scss'

const TableBody = (props: any) => {
  const {
    data,
    body,
    deleteRow,
    editRow,
    integrationRow,
    onRowClick,
    withoutActions,
  } = props

  const renderDataCol = (dataRow: any, fieldName: any) => {
    const { data: row } = dataRow
    if (fieldName && fieldName.name && row && row[fieldName.name]) {
      return (
        <div>
          {row[fieldName.name].media && (
            <div className="defaultMedia">
              <div className="userMedia">
                <img
                  className="media"
                  src={row[fieldName.name].media}
                  alt="media"
                  onError={(i) => {
                    ; (i.target as any).style.display = 'none'
                  }}
                />
              </div>
            </div>
          )}
          {(row[fieldName.name].title || row[fieldName.name].title === 0) && (
            <div className="titleTable">{row[fieldName.name].title}</div>
          )}
          {((row[fieldName.name].status && row[fieldName.name].status === 0) ||
            row[fieldName.name].subtitle) && (
              <div className="wrapperStatus">
                {row[fieldName.name].subtitle && (
                  <div className="subtitleTable">
                    {row[fieldName.name].subtitle}
                  </div>
                )}
              </div>
            )}
        </div>
      )
    }
    if (
      fieldName &&
      fieldName.name &&
      (dataRow[fieldName.name] || dataRow[fieldName.name] === 0)
    ) {
      return (
        <div>
          <div className="titleTable">{dataRow[fieldName.name].title}</div>
        </div>
      )
    }
    return null
  }

  return (
    <div className="tableBody">
      {data.map((dataRow: any, rowIndex: any) => {
        return (
          <div
            className={classnames(
              'tr',
              `${dataRow.statusValue}` && dataRow.status === 0
                ? 'rowStatusDisabled'
                : null,
            )}
            key={`table--row--${rowIndex}`}
          >
            {body.map((fieldName: any, index: any) => {
              if (index < body.length - 1) {
                return (
                  <div
                    role="link"
                    tabIndex={-10}
                    onKeyDown={() => { }}
                    onClick={() => onRowClick && onRowClick(dataRow.id)}
                    className={classnames(
                      'td',
                      onRowClick ? 'withClick' : null,
                      fieldName.name === ('price' || 'clicks' || 'impressions')
                        ? 'whiteSpace'
                        : null,
                    )}
                    key={`table--cell--${fieldName.name}--${index}`}
                  >
                    {renderDataCol(dataRow, fieldName)}
                  </div>
                )
              }

              if (!withoutActions) {
                return (
                  <div className="td" key={`table--action--cell--${rowIndex}`}>
                    {(editRow || integrationRow || deleteRow) && (
                      <div className="actionsButton">
                        <div
                          className={classnames(
                            'actions',
                            editRow && integrationRow && deleteRow
                              ? 'long'
                              : null,
                          )}
                        >
                          {integrationRow && (
                            <div
                              className="action integration"
                              role="button"
                              tabIndex={-10}
                              onKeyDown={() => { }}
                              onClick={() =>
                                integrationRow(dataRow.id, dataRow)
                              }
                            />
                          )}
                          {editRow && (
                            <div
                              className="action edit"
                              role="button"
                              tabIndex={-10}
                              onKeyDown={() => { }}
                              onClick={() => editRow(dataRow.id, dataRow)}
                            />
                          )}
                          {deleteRow && (
                            <div
                              className="action delete"
                              role="button"
                              tabIndex={-10}
                              onKeyDown={() => { }}
                              onClick={() => deleteRow(dataRow.id, dataRow)}
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )
              }

              return (
                <div
                  role="link"
                  tabIndex={-10}
                  onKeyDown={() => { }}
                  onClick={() => onRowClick && onRowClick(dataRow.id)}
                  className={classnames(
                    'td',
                    withoutActions ? 'withoutActions' : null,
                    onRowClick ? 'withClick' : null,
                    fieldName.name === ('price' || 'clicks' || 'impressions')
                      ? 'whiteSpace'
                      : null,
                    `${dataRow.statusValue}` && dataRow.status === 0
                      ? 'canceledCampaign'
                      : null,
                  )}
                  key={`table--cell--${fieldName.name}--${index}`}
                >
                  {renderDataCol(dataRow, fieldName)}
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

export default TableBody
